import styled from 'styled-components';
import base from './base';
import mediaQueries from './mediaQueries';

export const TextStyled = styled.span`
  ${base} ${mediaQueries};
`;
